/**
 * @generated SignedSource<<54c3562f598d32e90eb6df67f72be60c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type updatePageGeneralAssetFamilyQuery$variables = {
  generalAssetFamilyId: string;
};
export type updatePageGeneralAssetFamilyQueryVariables = updatePageGeneralAssetFamilyQuery$variables;
export type updatePageGeneralAssetFamilyQuery$data = {
  readonly generalAssetFamily: {
    readonly id: string;
    readonly createdAt: any;
    readonly name: string;
    readonly manufacturer: {
      readonly id: string;
      readonly name: string;
    };
  } | null;
};
export type updatePageGeneralAssetFamilyQueryResponse = updatePageGeneralAssetFamilyQuery$data;
export type updatePageGeneralAssetFamilyQuery = {
  variables: updatePageGeneralAssetFamilyQueryVariables;
  response: updatePageGeneralAssetFamilyQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "generalAssetFamilyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "generalAssetFamilyId",
    "variableName": "generalAssetFamilyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePageGeneralAssetFamilyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GeneralAssetFamily",
        "kind": "LinkedField",
        "name": "generalAssetFamily",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "manufacturer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePageGeneralAssetFamilyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GeneralAssetFamily",
        "kind": "LinkedField",
        "name": "generalAssetFamily",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "manufacturer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d84df8bbe6b852b3523bf6684c04fcc6",
    "id": null,
    "metadata": {},
    "name": "updatePageGeneralAssetFamilyQuery",
    "operationKind": "query",
    "text": "query updatePageGeneralAssetFamilyQuery(\n  $generalAssetFamilyId: ID!\n) {\n  generalAssetFamily(generalAssetFamilyId: $generalAssetFamilyId) {\n    id\n    createdAt\n    name\n    manufacturer {\n      __typename\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ee51bfa5f8d64d209b9f25a1e2192eb0";

export default node;
